import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { STATUS } from '../../utils/status';
import { UploadFileState } from '../interfaces/interface';
import { createUploadFile, uploadBulkQuestions } from '../slices/uploadFile';

const ExtraReducers = (builder: ActionReducerMapBuilder<UploadFileState>) => {
  builder
    .addCase(createUploadFile.pending, (state) => {
      state.uploadFileStatus = STATUS.PENDING;
      state.uploadFileMessage = ''
    })
    .addCase(createUploadFile.fulfilled, (state, action: PayloadAction<any>) => {
      state.data = action.payload.file_url;
      state.uploadFileStatus = STATUS.SUCESS;
      state.uploadFileMessage = action.payload?.message || "Success"
    })
    .addCase(createUploadFile.rejected, (state, action: any) => {
      state.uploadFileStatus = STATUS.FAILED;
      state.uploadFileMessage = action.payload?.message || "An error occurred"  
    })
    .addCase(uploadBulkQuestions.pending, (state) => {
      state.uploadBulkQuestionStatus = STATUS.PENDING;
      state.uploadBulkQuestionMessage = '';
    })
    .addCase(uploadBulkQuestions.fulfilled, (state, action: PayloadAction<any>) => {
      state.uploadBulkQuestionData = action.payload.file_url;
      state.uploadBulkQuestionStatus = STATUS.SUCESS;
      state.uploadBulkQuestionMessage = action.payload?.message || 'Success';
    })
    .addCase(uploadBulkQuestions.rejected, (state, action: any) => {
      state.uploadBulkQuestionStatus = STATUS.FAILED;
      state.uploadBulkQuestionMessage = action.payload?.message || 'An error occurred';
    });
};

export default ExtraReducers;
